import { Postal } from 'types/postal'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'

const resource = 'postals'

export const requests = {
  fetchPostal: async (postal: string) => {
    return await axiosForGigbaseBiz.get<DataResponse<Postal>>(
      mergeURL(resource, 'address'),
      {
        params: { postal },
      },
    )
  },
}
